module.exports = __webpack_public_path__ + "static/media/NouvelR-Regular.18f8130b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/nouvel/NouvelR-Regular.eot
// module id = 743
// module chunks = 6